// 页面路由配置
export default [
    {
        path: '/',
        name: 'home',
        redirect: 'productStore'
    },
    {
        path: '/productStore',
        name: 'productStore',
        meta: {
            title: '产品商城',
            keepAlive: true // true 表示需要使用缓存
        },
        component: () => import('../views/product/store.vue')
    },
    {
        path: '/secondProduct',
        name: 'secondProduct',
        meta: {
            title: '二级筛选'
        },
        component: () => import('../views/product/secondProduct.vue')
    },
    {
        path: '/filterProduct',
        name: 'filterProduct',
        meta: {
            title: '产品筛选'
        },
        component: () => import('../views/product/filterProduct.vue')
    },
    {
        path: '/searchProduct',
        name: 'searchProduct',
        meta: {
            title: '搜索'
        },
        component: () => import('../views/product/search.vue')
    },
    {
        path: '/productDetails',
        name: 'productDetails',
        meta: {
            title: '产品详情',
            // keepAlive: true // true 表示需要使用缓存
        },
        component: () => import('../views/product/details.vue')
    },
    {
        path: '/caseShare',
        name: 'caseShare',
        meta: {
            title: '客户案例分享',
            keepAlive: true // true 表示需要使用缓存
        },
        component: () => import('../views/caseShare/caseShare.vue')
    },
    {
        path: '/caseDetail',
        name: 'caseDetail',
        meta: {
            title: '案例内容'
        },
        component: () => import('../views/caseShare/caseDetail.vue')
    },
    {
        path: '/sceneActivity',
        name: 'sceneActivity',
        meta: {
            title: '小 E 活动',
            keepAlive: true // true 表示需要使用缓存
        },
        component: () => import('../views/sceneActivity/sceneActivity.vue')
    },
    {
        path: '/activityDetail',
        name: 'activityDetail',
        meta: {
            title: '活动详情',
            // keepAlive: true
        },
        component: () => import('../views/sceneActivity/activityDetail.vue')
    },
    {
        path: '/solutionClassify',
        name: 'solutionClassify',
        meta: {
            title: '应用方案',
            keepAlive: true // true 表示需要使用缓存
        },
        component: () => import('../views/solution/solutionClassify.vue')
    },
    {
        path: '/solutionList',
        name: 'solutionList',
        meta: {
            title: '应用方案',
            keepAlive: true // true 表示需要使用缓存
        },
        component: () => import('../views/solution/solutionList.vue')
    },
    {
        path: '/solutionDetails',
        name: 'solutionDetails',
        meta: {
            title: '详情'
        },
        component: () => import('../views/solution/solutionDetails.vue')
    },
    {
        path: '/addLabel',
        name: 'addLabel',
        meta: {
            title: '添加标签'
        },
        component: () => import('../views/addLabel/addLabel.vue')
    },
    {
        path: '/test',
        name: 'test',
        meta: {
            title: '活动详情'
        },
        component: () => import('../views/demo/test.vue')
    },
    {
        path: '/applyQuotation',
        name: 'applyQuotation',
        meta: {
            title: '申请报价'
        },
        component: () => import('../views/apply/quotation.vue')
    },
    {
        path: '/centrifuge',
        name: 'centrifuge',
        meta: {
            title: '按应用选型',
            // keepAlive: true
        },
        component: () => import('../views/centrifuge/centrifuge.vue')
    },
    {
        path: '/newCentrif',
        name: 'newCentrif',
        meta: {
            title: '离心机',
        },
        component: () => import('../views/centrifuge/newCentrif.vue')
    },
    {
        path: '/centrifugeDetails',
        name: 'centrifugeDetails',
        meta: {
            title: '产品详情'
        },
        component: () => import('../views/centrifuge/details.vue')
    },
    {
        path: '/channelTrack',
        name: 'channelTrack',
        meta: {
            title: '渠道中心'
        },
        component: () => import('../views/channelTrack/index.vue')
    },
    {
        path: '/pricacy',
        name: 'pricacy',
        meta: {
            title: '隐私条款',
            keepAlive: true
        },
        component: () => import('../views/pricacy/index.vue')
    },
    {
        path: '/sucker',
        name: 'sucker',
        meta: {
            title: '吸头筛选'
        },
        component: () => import('../views/sucker/index.vue')
    },
    {
        path: '/polyDetail',
        name: 'polyDetail',
        meta: {
            title: '详情页',
            keepAlive: true
        },
        component: () => import('../views/polymerize/detail.vue')
    },
    {
        path: '/classDetail',
        name: 'classDetail',
        meta: {
            title: '详情页'
        },
        component: () => import('../views/polymerize/classDetail.vue')
    },
    {
        path: '/homeIndex',
        name: 'homeIndex',
        meta: {
            title: '首页'
        },
        component: () => import('../views/home/homeIndex.vue')
    },
    {
        path: '/centrifugeHome',
        name: 'centrifugeHome',
        meta: {
            title: '离心直通车'
        },
        component: () => import('../views/centrifugeAera/centrifugeHome.vue')
    },
    {
        path: '/programme',
        name: 'cenProgramme',
        meta: {
            title: '离心方案'
        },
        component: () => import('../views/centrifugeAera/programme.vue')
    },
    {
        path: '/programmeDetail',
        name: 'programmeDetail',
        meta: {
            title: '详情页'
        },
        component: () => import('../views/centrifugeAera/programmeDetail.vue')
    },
    {
        path: '/proModel',
        name: 'proModel',
        meta: {
            title: '产品及选型',
            keepAlive: true
        },
        component: () => import('../views/centrifugeAera/proModel.vue')
    },
    {
        path: '/operateUse',
        name: 'operateUse',
        meta: {
            title: '操作使用'
        },
        component: () => import('../views/centrifugeAera/operateUse.vue')
    },
    {
        path: '/operateGuide',
        name: 'operateGuide',
        meta: {
            title: '快速操作指南'
        },
        component: () => import('../views/centrifugeAera/operateGuide.vue')
    },
    {
        path: '/trove',
        name: 'trove',
        meta: {
            title: '离心宝典'
        },
        component: () => import('../views/centrifugeAera/trove.vue')
    },
    {
        path: '/correctUse',
        name: 'correctUse',
        meta: {
            title: '正确使用'
        },
        component: () => import('../views/centrifugeAera/correctUse.vue')
    },
    {
        path: '/knowUs',
        name: 'knowUs',
        meta: {
            title: '了解我们'
        },
        component: () => import('../views/centrifugeAera/knowUs.vue')
    },
    {
        path: '/solutionHome',
        name: 'solutionHome',
        meta: {
            title: '应用方案'
        },
        component: () => import('../views/solutionHome/solutionHome.vue')
    },
    {
        path: '/pipetteHome',
        name: 'pipetteHome',
        meta: {
            title: '移液加速站'
        },
        component: () => import('../views/pipette/pipetteHome.vue')
    },
    {
        path: '/pipProduct',
        name: 'pipProduct',
        meta: {
            title: '移液器商城'
        },
        component: () => import('../views/pipette/pipProduct.vue')
    },
    {
        path: '/pipetteUse',
        name: 'pipetteUse',
        meta: {
            title: '移液器知识库'
        },
        component: () => import('../views/pipette/pipetteUse.vue')
    },
    {
        path: '/pipOperVideo',
        name: 'pipOperVideo',
        meta: {
            title: '移液器操作视频'
        },
        component: () => import('../views/pipette/pipOperVideo.vue')
    },
    {
        path: '/pipOperDetail',
        name: 'pipOperDetail',
        meta: {
            title: '详情'
        },
        component: () => import('../views/pipette/pipOperDetail.vue')
    },
    {
        path: '/pipSelection',
        name: 'pipSelection',
        meta: {
            title: '选型工具'
        },
        component: () => import('../views/pipette/pipSelection.vue')
    },
    {
        path: '/pipMaintain',
        name: 'pipMaintain',
        meta: {
            title: '维护保养'
        },
        component: () => import('../views/pipette/pipMaintain.vue')
    },
    {
        path: '/pipUserStory',
        name: 'pipUserStory',
        meta: {
            title: '用户故事'
        },
        component: () => import('../views/pipette/pipUserStory.vue')
    },
    {
        path: '/pipStoryDetail',
        name: 'pipStoryDetail',
        meta: {
            title: '详情'
        },
        component: () => import('../views/pipette/pipStoryDetail.vue')
    },
    {
        path: '/pipClassRoom',
        name: 'pipClassRoom',
        meta: {
            title: '科普小课堂'
        },
        component: () => import('../views/pipette/pipClassRoom.vue')
    },
    {
        path: '/newSpecial',
        name: 'newSpecial',
        meta: {
            title: '新品&活动专区'
        },
        component: () => import('../views/centrifugeAera/newSpecial.vue')
    },
    {
        path: '/rotor',
        name: 'rotor',
        meta: {
            title: '常用转子'
        },
        component: () => import('../views/rotor/rotor.vue')
    },
    {
        path: '/rotorDetail',
        name: 'rotorDetail',
        meta: {
            title: '转子详情'
        },
        component: () => import('../views/rotor/rotorDetail.vue')
    },
    {
        path: '/expendables',
        name: 'expendables',
        meta: {
            title: '耗材选型'
        },
        component: () => import('../views/rotor/expendables.vue')
    },
    {
        path: '/operateGuideCategory',
        name: 'operateGuideCategory',
        meta: {
            title: '操作维护指南'
        },
        component: () => import('../views/centrifugeAera/operateGuideCategory.vue')
    }
    
]
